var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticClass:"aspect-img",style:(_vm.style),attrs:{"src":_vm.imgSrc}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }